import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';
import { CampaignApiDetails } from 'schemas/CampaignApiDetails.schema';

function translateToCampaignConfig(campaignApiDetails: CampaignApiDetails): CampaignConfig {
  const campaignDetails = campaignApiDetails.campaign;

  const iterationDetails = campaignApiDetails.iterations?.length
    // eslint-disable-next-line camelcase
    ? campaignApiDetails.iterations.map(({ iteration_details, ...rest }) => ({
      // eslint-disable-next-line camelcase
      ID: iteration_details?.ID,
      ...rest,
    }))
    : [];

  const iterations = campaignApiDetails.iterations?.length
    ? campaignApiDetails.iterations.map((iteration) => ({
      ...iteration.iteration_details,
      IterationCohorts: iteration.iteration_details?.IterationCohorts ?? [],
      IterationRules: iteration.iteration_details?.IterationRules ?? [],
    }))
    : [];

  const campaignConfig : CampaignConfig = {
    ...campaignDetails,
    iteration_details: iterationDetails,
    CampaignConfig: {
      ...campaignDetails.CampaignConfig,
      Iterations: iterations,
    },
  };

  return campaignConfig;
}

export default translateToCampaignConfig;
